import { injectable } from 'inversify';
import { action, computed, makeObservable, observable } from 'mobx';
import type { IBoxIndicationStateStore } from '@/components/boxes/common/interfaces.ts';

@injectable()
export class BoxIndicationStateStore implements IBoxIndicationStateStore {
  @observable
  private _isIndicating = false;

  public constructor() {
    makeObservable(this);
  }

  @computed
  public get isIndicating(): boolean {
    return this._isIndicating;
  }

  @action
  public setIsIndicating(isIndicating: boolean): void {
    this._isIndicating = isIndicating;
  }
}
